import IAtomModel from "./IAtomModel";
import {ElementHelper} from '@alchemiesolns/elements';
import IVector from "./IVector";
import AtomChirality from './AtomChirality';

export default class AtomModel implements IAtomModel {
    symbol: string;
    charge: number;
    lonePairs: number;
    radicals: number;
    atomicNumber: number;
    pos?: IVector;
    // todo: get rid of these
    chirality?: AtomChirality; // maybe keep these for now bc what if in the future we allow authors to label r and s?
    isAliphatic: boolean = false;
    isAromatic: boolean = false;
    //
    visible: boolean = true; // maybe this too
    id?: string;
    constructor(symbol: string) {
        this.symbol = symbol;
        this.charge = 0;
        this.lonePairs = 0;
        this.radicals = 0;
        this.atomicNumber = ElementHelper.getAtomicNumberBySymbol(this.symbol);
    }

    get valence(): number {
        return ElementHelper.getValenceBySymbol(this.symbol);
    }

    get allowsSextet(): boolean {
        // Boron and Aluminum allow for a sextet
        return this.atomicNumber === 5 || this.atomicNumber === 13;
    }

    get allowsDuet(): boolean {
        // Hydrogen and Lithium have a duet rule.
        // Atomic number 0 is an unknown element or r group.
        return this.atomicNumber === 0 || this.atomicNumber === 1 || this.atomicNumber === 3;
    }

    get allowsQuartet(): boolean {
        // Beryllium has 2 valence electrons.
        return this.atomicNumber === 4 || this.atomicNumber === 12;
    }

    get hasExpandedOctet(): boolean {
        return this.atomicNumber >= 14;
    }

    copy(): IAtomModel {
        return {
            copy: this.copy,
            valence: this.valence,
            symbol: this.symbol,
            charge: this.charge,
            lonePairs: this.lonePairs,
            radicals: this.radicals,
            atomicNumber: this.atomicNumber,
            pos: this.pos,
            chirality: this.chirality,
            isAliphatic: this.isAliphatic,
            isAromatic: this.isAromatic,
            visible: this.visible,
            id: this.id
        }
    }

}
